import request from './axios.js'
// 登录
export function login (data) {
    return request({
      url: '/api/Login/index',
      method: 'post',
      data
    })
}

// 根据邮箱判断是否已注册（LenovoID 登录流程）
export function ifGkRegister (email) {
  return request({
    url: '/api/Login/ifGkRegister',
    method: 'get',
    params: { email }
  })
}

// -----------------------------------------------------------------------------考试列表
// 考试列表
export function Exam_index (data) {
  return request({
    url: '/api/Exam/index',
    method: 'post',
    data
  })
}
// 获取考试详情   /api/Exam/getInfo
export function ExamAnswer_getInfo (data) {
  return request({
    url: '/api/ExamAnswer/getInfo',
    method: 'get',
    params:data
  })
}
// 创建试卷
export function examsession (data) {
  return request({
    url: '/api/ExamAnswer/examsession',
    method: 'post',
    data
  })
}
// 获取试卷 /api/ExamAnswer/getsession
export function getsession (data) {
  return request({
    url: '/api/ExamAnswer/getsession',
    method: 'get',
    data
  })
}
// 考生答卷 /api/ExamAnswer/add
export function ExamAnswer_add (data) {
  return request({
    url: '/api/ExamAnswer/add',
    method: 'post',
    data
  })
}

// ------------------------------------------------------------------------------------------考试记录模块

// 考试记录 /api/ExamHistory/index

export function ExamHistory_index (data) {
  return request({
    url: '/api/ExamHistory/index',
    method: 'post',
    data
  })
}

// 答卷详情 （未阅卷未评分） /api/ExamHistory/getInfo
export function ExamHistory_getInfo (data) {
  return request({
    url: '/api/ExamHistory/getInfo',
    method: 'get',
    data,
    params:data
  })
}

// 答卷详情 （未阅卷未评分） /api/ExamHistory/getInfo
export function ExamHistory_getInfo2 (data) {
  return request({
    url: '/api/ExamHistory/getInfo2',
    method: 'get',
    params:data
  })
}

//  考试管理-----------------------------------------------------------------------------------------------
// 考试列表 /api/ExamPaper/index
export function ExamPaper_index (data) {
  return request({
    url: '/api/Exam/lists',
    method: 'post',
    data,
  })
}
// 发布考试  /api/Exam/addExam
export function ExamPaper_addExam (data) {
  return request({
    url: '/api/Exam/addExam',
    method: 'post',
    data
  })
}
// 获取考试详情 /api/Exam/getExam
export function Exam_getExam (data) {
  return request({
    url: '/api/Exam/getExam',
    method: 'get',
    params:data
  })
}
// 编辑考试 /api/Exam/updateExam
export function Exam_updateExam (data) {
  return request({
    url: '/api/Exam/updateExam',
    method: 'post',
    data
  })
}

// 删除考试
export function Exam_delExam (data) {
  return request({
    url: '/api/Exam/delExam',
    method: 'get',
    params:data
  })
}
// 复制考试  /api/Exam/copy
export function Exam_copy (data) {
  return request({
    url: '/api/Exam/copy',
    method: 'get',
    params:data
  })
}

// ------------------------------试卷管理
// 试卷列表  /api/ExamPaper/indexp
export function ExamPaper_indexp (data) {
  return request({
    url: '/api/ExamPaper/index',
    method: 'post',
    data,
  })
}
// 删除试卷  /api/ExamPaper/del
export function  ExamPaper_del (data) {
  return request({
    url: '/api/ExamPaper/del',
    method: 'get',
    params:data
  })
}

// 组织列表  /api/Organize/index
export function  Organize_index (data) {
  return request({
    url: ' /api/Organize/index',
    method: 'get',
    data,
    params:data
  })
}
// 添加试题 /api/Question/add
export function  Question_add(data) {
  return request({
    url: '/api/Question/add',
    method: 'post',
    data,
  })
}
// 试题分类 /api/QuestionBasic/index ---------------------------------------------
export function  QuestionBasic_index(data) {
  return request({
    url: '/api/QuestionBasic/index',
    method: 'post',
    data,
  })
}
// 添加试题分类 /api/QuestionBasic/add
export function  QuestionBasic_add(data) {
  return request({
    url: '/api/QuestionBasic/add',
    method: 'post',
    data,
  })
}
// 删除试题分类
export function  QuestionBasic_del(data) {
  return request({
    url: '/api/QuestionBasic/del',
    method: 'get',
    params:data,
  })
}
//获取试题分类 /api/QuestionBasic/getInfo
export function  QuestionBasic_getInfo(data) {
  return request({
    url: '/api/QuestionBasic/getBasic',
    method: 'get',
    params:data,
  })
}
// /api/QuestionBasic/update 修改试题分类
export function  QuestionBasic_update(data) {
  return request({
    url: '/api/QuestionBasic/update',
    method: 'post',
    data,
  })
}
// ---------------------------------------------------主观题阅卷
// /api/ExamScore/index 试卷主观题列表
export function  ExamScore_index(data) {
  return request({
    url: '/api/ExamScore/index',
    method: 'get',
    params:data
  })
}
// /api/ExamScore/questionList 答题记录列表
export function  ExamScore_questionList(data) {
  return request({
    url: '/api/ExamScore/questionList',
    method: 'post',
    data
  })
}
// /api/ExamScore/getSubject 主观题详情
export function  ExamScore_getSubject(data) {
  return request({
    url: '/api/ExamScore/getSubject',
    method: 'post',
    data
  })
}
// /api/ExamScore/grade 主观题评分
export function  ExamScore_grade(data) {
  return request({
    url: '/api/ExamScore/grade',
    method: 'post',
    data
  })
}
// /api/ExamScore/questionCount 答题阅卷统计
export function  ExamScore_questionCount(data) {
  return request({
    url: '/api/ExamScore/questionCount',
    method: 'get',
    params:data
  })
}
//  /api/ExamScore/getAnswer 答案详情列表
export function  ExamScore_getAnswer(data) {
  return request({
    url: '/api/ExamScore/getAnswer',
    method: 'post',
    data
  })
}


//----------------------------------------------------------------------
// 试题列表 /api/Question/index
export function  Question_index(data) {
  return request({
    url: '/api/Question/index',
    method: 'post',
    data,
  })
}
// 试题图片上传  /api/Question/upload
export function Question_upload(data) {
  return request({
    url: '/api/Question/upload',
    method: 'post',
    data,
  })
}
// 编辑试题--获取试题详情 /api/Question/getInfo
export function  Question_getInfo(data) {
  return request({
    url: '/api/Question/getInfo',
    method: 'get',
    data,
    params:data
  })
}
// 编辑试题 /api/Question/update
export function  Question_update(data) {
  return request({
    url: '/api/Question/update',
    method: 'post',
    data,
  })
}
// 删除试题 /api/Question/del
export function  Question_del(data) {
  return request({
    url: '/api/Question/del',
    method: 'get',
    params:data
  })
}

// -------------------------创建试卷---------------------------------------------
// 创建普通试卷 /api/ExamPaper/add

export function  ExamPaper_add (data) {
  return request({
    url: ' /api/ExamPaper/add',
    method: 'post',
    data,
  })
}
// 获取普通试卷 /api/ExamPaper/getInfo1
export function  ExamPaper_getInfo1 (data) {
  return request({
    url: '/api/ExamPaper/getInfo1',
    method: 'get',
    params:data
  })
}
// 创建抽题试卷
export function  ExamPaper_add2 (data) {
  return request({
    url: ' /api/ExamPaper/add2',
    method: 'post',
    data,
  })
}
// 获取抽题试卷 /api/ExamPaper/getInfo2
export function  ExamPaper_getInfo2 (data) {
  return request({
    url: '/api/ExamPaper/getInfo2',
    method: 'get',
    params:data
  })
}
// 创建随机试卷
export function  ExamPaper_add3 (data) {
  return request({
    url: ' /api/ExamPaper/add3',
    method: 'post',
    data,
  })
}
// 获取随机试卷 /api/ExamPaper/getInfo3
export function  ExamPaper_getInfo3 (data) {
  return request({
    url: '/api/ExamPaper/getInfo3',
    method: 'get',
    params:data
  })
}
// 获取随机统计
export function  ExamPaper_getBasic (data) {
  return request({
    url: '/api/ExamPaper/getBasic',
    method: 'get',
    params:data
  })
}
// 编辑试卷 /api/ExamPaper/update
export function  ExamPaper_update (data) {
  return request({
    url: '/api/ExamPaper/update',
    method: 'post',
    data
  })
}
// 复制试卷 /api/ExamPaper/copy
export function  ExamPaper_copy (data) {
  return request({
    url: '/api/ExamPaper/copy',
    method: 'get',
    params:data
  })
}

// 获取试题详情列表
// /api/Question/getList
export function  Question_getList (data) {
  return request({
    url: '/api/Question/getList',
    method: 'post',
    data,
  })
}

//------------------------------------------------------------------------------统计管理模块
// /api/ExamStatistics/person   人员考试统计
export function  ExamStatistics_person  (data) {
  return request({
    url: '/api/ExamStatistics/person ',
    method: 'post',
    data,
  })
}  

// 考生详情 /api/ExamStatistics/personlist
export function  ExamStatistics_personlist  (data) {
  return request({
    url: '/api/ExamStatistics/personlist',
    method: 'post',
    data,
  })
}  

// 考试列表 /api/ExamStatistics/examList
export function  ExamStatistics_examList  (data) {
  return request({
    url: '/api/ExamStatistics/examList',
    method: 'post',
    data,
  })
}  
// 考试统计列表 /api/ExamStatistics/exam
export function  ExamStatistics_exam  (data) {
  return request({
    url: '/api/ExamStatistics/exam',
    method: 'post',
    data,
  })
}  
// 统计分析模块  /api/ExamStatistics/report
export function  ExamStatistics_report  (data) {
  return request({
    url: ' /api/ExamStatistics/report',
    method: 'get',
    params:data,
  })
}  

//---------------------------------------------------------------用户角色管理
// 用户列表 /api/User/index
export function User_index  (data) {
  return request({
    url: '/api/User/index',
    method: 'post',
    data,
  })
} 
// 用户添加 /api/User/add
export function User_add (data) {
  return request({
    url: '/api/User/add',
    method: 'post',
    data,
  })
} 
// 编辑用户 /api/User/update
export function User_update (data) {
  return request({
    url: '/api/User/update',
    method: 'post',
    data,
  })
}
// 获取用户信息 /api/User/getInfo
export function User_getInfo (data) {
  return request({
    url: '/api/User/userInfo',
    method: 'get',
    params:data,
  })
}
// 删除用户  /api/User/del
export function User_del (data) {
  return request({
    url: '/api/User/del',
    method: 'get',
    params:data,
  })
}
// 禁用用户 /api/User/active
export function User_active(data) {
  return request({
    url: '/api/User/active',
    method: 'get',
    params:data,
  })
}
// 权限列表 /api/Auths/index
export function Auths_index  (data) {
  return request({
    url: '/api/Auths/index',
    method: 'post',
    data,
  })
} 
// 删除用户组 /api/Auths/del
export function Auths_del  (data) {
  return request({
    url: '/api/Auths/del',
    method: 'get',
    params:data,
  })
} 
// 添加用户组 /api/Auths/addGroup
export function Auths_addGroup  (data) {
  return request({
    url: ' /api/Auths/addGroup',
    method: 'post',
    data,
  })
} 
// 获取用户组 /api/Auths/getGroup
export function Auths_getGroup  (data) {
  return request({
    url: '/api/Auths/getGroup',
    method: 'get',
    params:data,
  })
}
// 更新用户组 /api/Auths/updateGroup
export function Auths_updateGroup  (data) {
  return request({
    url: '/api/Auths/updateGroup',
    method: 'post',
    data,
  })
}
// 获取用户组权限 /api/Auths/getRule
export function Auths_getRule  (data) {
  return request({
    url: '/api/Auths/getRule',
    method: 'get',
    params:data
  })
}
// 更新用户组权限  /api/Auths/updateRule
export function Auths_updateRule  (data) {
  return request({
    url: '/api/Auths/updateRule',
    method: 'post',
    data
  })
}
// 系统退出 /api/Login/loginOut
export function loginOut (data) {
  return request({
    url: '/api/Login/loginOut',
    method: 'get',
    params:data
  })
}
// 阅卷前是否有人做卷检测 /api/Exam/check
export function Exam_check (data) {
  return request({
    url: '/api/Exam/check',
    method: 'get',
    params:data
  })
}
// 导出excel----------------------------------------------------------------------------------------
// 错题导出 /api/Question/export
export function Question_export (data) {
  return request({
    url: ' /api/Question/export',
    method: 'post',
    data,
    responseType: 'blob'
  })
} 
// 阅卷导出  /api/ExamScore/export
export function  ExamScore_export (data) {
  return request({
    url: '/api/ExamScore/export',
    method: 'post',
    data,
    responseType: 'blob'
  })
} 
// 菜单权限获取 /api/Login/menu
export function Login_menu (data) {
  return request({
    url: '/api/Login/menu',
    method: 'get',
    params:data
  })
}
// 知识点管理 
// 知识点列表   /api/QuestionPoint/inde
export function QuestionPoint_index (data) {
  return request({
    url: '/api/QuestionPoint/index',
    method: 'get',
    params:data
  })
}
// 删除知识点 /api/QuestionPoint/del
export function QuestionPoint_del (data) {
  return request({
    url: '/api/QuestionPoint/del',
    method: 'get',
    params:data
  })
}
// 知识点添加 api/QuestionPoint/add
export function QuestionPoint_add  (data) {
  return request({
    url: '/api/QuestionPoint/add',
    method: 'post',
    data
  })
}
// 获取知识点详情 /api/QuestionPoint/getInfo
export function QuestionPoint_getInfo (data) {
  return request({
    url: '/api/QuestionPoint/getInfo',
    method: 'get',
    params:data
  })
}
// 修改详情 QuestionPoint_update
export function QuestionPoint_update  (data) {
  return request({
    url: '/api/QuestionPoint/update',
    method: 'post',
    data
  })
}
// 考试记录分析导出 /api/ExamStatistics/export2
export function ExamStatistics_export2  (data) {
  return request({
    url: '/api/ExamStatistics/export2',
    method: 'get',
    params:data
  })
}


// WEBPACK FOOTER //
// ./src/assets/js/api.js